import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { GenerateIRSFileService } from './readytosubmitirs.service';
import * as _ from 'lodash';
import { file1094Service } from '../file1094/file1094.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
  selector: 'app-generate-irsfile',
  templateUrl: './readytosubmitirs.component.html',
  providers: [GenerateIRSFileService, file1094Service],
  styleUrls: ['./readytosubmitirs.component.css']
})
export class GenerateIRSFileComponent implements OnInit {

  dataLoaded: boolean;
  public errorYear: boolean = false;
  generateIRSList: Array<any> = [];
  public einList: any = [];
  public selectedYear: string[];
  public selectedEIN: string[];
  public selectedGroup: string[];
  taxYearList:any = [];
  controlGroupList:any = [];
  public loading = false;
  public rows: Array<any> = [];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public lenghtofdata: any;
  title: string;
  selecttitle: any;
  optionsModel: number[];

  public columns: Array<any> = [
    { title: 'Tax Year', className: 'va-m', name: 'taxYear' },
    { title: 'Controlled Group', className: 'va-m', name: 'controlGroup' },
    { title: 'ALE Name', className: 'va-m', name: 'aleName' },
    { title: 'EIN', className: 'va-m', name: 'ein' },
    { title: '1095 Status', className: 'va-m', name: 'f1095Status' },
    { title: '1094 Count Status', className: 'va-m', name: 'f1095CountStatus' },
    { title: 'Client Approved status', className: 'va-m', name: 'clientApprovedStatus' },
    { title: 'Client approved date', className: 'va-m', name: 'clientApprovedDate' }
  ];

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table', 'table-striped', 'table-bordered', 'table-hover']
  };
  cgDropdownSettings = {
    singleSelection: false,
    text: 'Select Controlled Group',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    badgeShowLimit: 3
  };

  taxyearDropdownSettings = {
    singleSelection: false,
    text: 'Select TaxYear',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    badgeShowLimit: 3
  };

  einDropdownSettings = {
    singleSelection: false,
    text: 'Select EIN',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    badgeShowLimit: 3
  };

  selectedCgValues:any = [];
  selectedTaxYearValues:any = [];
  selectedEinValues:any = [];
  isfilterloaded: boolean = false;
  constructor(private service: GenerateIRSFileService, private file1094Serv: file1094Service) { }

  //Get taxyears on load
  ngOnInit() {
    this.taxYearList = [];
    this.service.getTaxyears().subscribe(data => {
      data.forEach((element:any) => {
        this.taxYearList.push({ id: element, itemName: element })
      });
    });
  }

  //on tax year change, get controlled group and ein list
  ontaxYearChange() {
    this.selectedYear = this.selectedTaxYearValues ? this.selectedTaxYearValues.map((item:any) => item.itemName) : [];
    this.controlGroupList = [];
    this.einList = []; 
    if (this.selectedYear.length) {
      this.service.getControlgroup(this.selectedYear).subscribe(data => {
        this.selectedEinValues = this.selectedEinValues.filter((element:any) => data.ein.includes(element.itemName));
        this.selectedCgValues = this.selectedCgValues.filter((element:any) => data.controlGroup.includes(element.itemName));
        data.controlGroup.forEach((element:any) => {
          this.controlGroupList.push({ id: element, itemName: element })
        });
        data.ein.forEach((element:any) => {
          this.einList.push({ id: element, itemName: element })
        });
        this.onChangeControlledGroup();
        this.onChangeEin();
      });
    }else{
      this.selectedEinValues = [];
      this.selectedCgValues = [];
    }
  }

  // format the selected filter values and get an object
  getFilterValues(): any {
    let year = this.selectedYear;
    if (year === undefined) {
      year = [];
      year[0] = '';
      this.selectedYear = [];
    }
    if (year !== undefined && year.length <= 0) {
      year[0] = '';
      this.selectedYear = [];
    }
    let cg = this.selectedGroup;
    if (cg === undefined) {
      cg = [];
      cg[0] = '';
      this.selectedGroup = [];
    }
    if (cg !== undefined && cg.length <= 0) {
      cg[0] = '';
      this.selectedGroup = [];
    }

    let ein = this.selectedEIN;
    if (ein === undefined) {
      ein = [];
      ein[0] = '';
      this.selectedEIN = [];
    }
    if (ein !== undefined && ein.length <= 0) {
      ein[0] = '';
      this.selectedEIN = [];
    }
    let filterCriteria: any = {
      selectedYear: year.join(','),
      selectedControlGroup: cg.join(','),
      selectedEIN: ein.join(','),
    };
    return filterCriteria;
  }

  // get report data based on selected filter data and clicks on search button
  getAllGenerateIRS() {
    this.errorYear = false;
    const filterCriteria = this.getFilterValues();
    this.loading = true;
    if(!this.selectedYear.length || !filterCriteria.selectedControlGroup.length){
      this.errorYear = true;
      this.loading = false;
      return false;
    }
    this.page = 1;
    this.isfilterloaded = true;
    this.service.getReportData(filterCriteria).subscribe(data => {
      this.generateIRSList = data;
      this.dataLoaded = true;
      this.loading = false;
      this.onChangeTable(this.config);
      this.isfilterloaded = false;
    },
      (error) => this.loading = false);
  }

  // Reset filter dropdowns once user click on reset button
  reset(): void {
    this.loading = false;
    this.dataLoaded = false;
    this.selectedYear = [];
    this.selectedEIN = [];
    this.selectedGroup = [];
    this.controlGroupList = [];
    this.einList = [];
    this.selectedCgValues = [];
    this.selectedTaxYearValues = [];
    this.selectedEinValues = [];
    this.controlGroupList = [];
    this.einList = [];
    this.errorYear = false;
  }

  // ng2 smart table configuration
  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.generateIRSList, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }
  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }
    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }
    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name] == null) {
          item[column.name] = '';
        }
      });
      this.columns.forEach((column: any) => {
        if (item[column.name] && item[column.name].toLowerCase().match(this.config.filtering.filterString)) {
          flag = true;
        }
        else if (item[column.name] && item[column.name].toUpperCase().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }
  public changePage(page: any, data: Array<any> = this.generateIRSList): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  onChangeControlledGroup(){
    this.selectedGroup = this.selectedCgValues ? this.selectedCgValues.map((item:any) => item.itemName) : [];
  }
  onChangeEin(){
    this.selectedEIN = this.selectedEinValues ? this.selectedEinValues.map((item:any) => item.itemName) : [];
  }
  onDeSelectAll(){
    this.selectedCgValues = [];
    this.selectedEinValues = [];
 }
}



// WEBPACK FOOTER //
// ./src/app/readytosubmitirs/readytosubmitirs.component.ts